import { motion } from 'framer-motion';
import { sectionAnimVariants } from '../../constants/animationVariants';
import { useAuthContext } from '../../contexts/AuthProvider';
import usePackageActions from '../../hooks/APIHooks/finance/usePackageActions';
import useCheckUserFeaturePermissions from '../../hooks/useCheckUserFeaturePermissions';
import AcademiaNotFound from '../CommonComps/AcademiaNotFound';
import PackageCard from '../CommonComps/Cards/PackageCard';
import AcademiaLoading from '../CommonComps/Loadings/AcademiaLoading';
import NoTableDataFound from '../CommonComps/NoTableDataFound';
import PageHeader from '../CommonComps/Titles/PageHeader';
import CreatePackageAction from './CreatePackageAction';

const ShowAllPackages = () => {
  // integration of custom API hooks here
  const { getPackageListHandler } = usePackageActions('packageList');

  // integration of context hooks here
  const { currentUserType } = useAuthContext();

  // integration of custom hooks here
  const { featureBasedPermissions } = useCheckUserFeaturePermissions(
    'creditPackage',
    true
  );

  console.log('PACKAGE LIST: ', getPackageListHandler.data?.data);

  // rendering show all packages section component here
  return (
    <section>
      {getPackageListHandler.isLoading ? (
        <AcademiaLoading />
      ) : getPackageListHandler.isSuccess ? (
        featureBasedPermissions?.includes('READ') ? (
          <>
            <PageHeader
              headerText='All Packages'
              additionalComponent={
                currentUserType !== 'client' ? (
                  <CreatePackageAction
                    hasCreatePermission={featureBasedPermissions.includes(
                      'CREATE'
                    )}
                  />
                ) : undefined
              }
            />

            {getPackageListHandler.data.data.length ? (
              <motion.div
                variants={sectionAnimVariants}
                initial='initial'
                animate='animate'
                className='grid md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-6 mt-10 px-2 md:px-0'
              >
                {getPackageListHandler.data.data.map((creditPackage) => (
                  <PackageCard
                    key={creditPackage.id}
                    creditPackage={creditPackage}
                    hasDeletePermission={featureBasedPermissions.includes(
                      'DELETE'
                    )}
                    hasUpdatePermission={featureBasedPermissions.includes(
                      'UPDATE'
                    )}
                  />
                ))}
              </motion.div>
            ) : (
              <NoTableDataFound message='No Packages Found!!' />
            )}
          </>
        ) : (
          <AcademiaLoading />
        )
      ) : getPackageListHandler.isError ? (
        <AcademiaNotFound message='Failed to load package data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllPackages;
